import React from 'react';

const NumberInput = React.forwardRef(({ onChange, ...props }, ref) => {
    const handleWheel = (event) => {
        event.target.blur();
    };

    return (
        <input
            ref={ref}
            type="number"
            onWheel={handleWheel}
            {...props}
            onChange={onChange}
        />
    );
});

export default NumberInput;
